import React, { Fragment } from 'react'
import { 
    Typography
} from '@mui/material';

import DoneAllIcon from '@mui/icons-material/DoneAll';
import UpdateIcon from '@mui/icons-material/Update';




const PackageStatus = ({...props}) => {

    const { isComplete } = props;

    return (
        <Fragment>
            {isComplete && 
                <Typography variant="overline" style={{color:"green"}}>
                    <DoneAllIcon /> Complete 
                </Typography>
            }
            {!isComplete &&
                <Typography variant="overline">
                    <UpdateIcon /> Pending
                </Typography>
            }
        </Fragment>         
    )
}

export default PackageStatus;